import Api from '@/services/Api';

export default {
  fetchPost(id , params ){
    return Api().get(`/vnfd/${id}`  , {params});
  },
  fetchPosts(params) {
    return Api().get('/vnfd', {params});
  },
}